export default function Answer({ inputAnswer, questionId, checkAnswer }) {
    return (
        <div className="answer" onClick={(e) => checkAnswer(questionId, inputAnswer.id,e)} id={questionId+"-"+inputAnswer.id}>
            {inputAnswer.answer}
        </div>
    )
}